// Redux Messages module
// see https://github.com/erikras/ducks-modular-redux

import { Messages } from '../../services/';
import { createRestSlices, applyReducers } from './rest';

const START_CREATING_MESSAGE   = 'kronos/messages/START_CREATING_MESSAGE';
const SET_USERS_IDS            = 'kronos/messages/SET_USERS_IDS';
const SET_ACTIVITIES_IDS       = 'kronos/messages/SET_ACTIVITIES_IDS';
const SET_RECIPIENTS           = 'kronos/messages/SET_RECIPIENTS';
const CREATING_MESSAGE         = 'kronos/messages/CREATING_MESSAGE';
const CREATING_MESSAGE_SUCCESS = 'kronos/messages/CREATING_MESSAGE_SUCCESS';
const CREATING_MESSAGE_FAILURE = 'kronos/messages/CREATING_MESSAGE_FAILURE';

const {
    initialState,
    linkedResourcesReducer,
    linkedResourcesAction
} = createRestSlices(Messages);

const defaultMessage = () => ({
    users_ids: [],
    activities_ids: [],
    recipients: [],
    custom_text: {},
    application_type_id: null,
    replyTo: null
});

initialState.isLoading                  = false;
initialState.hasLoadingError            = false;
initialState.loadingErrorMessage        = '';
initialState.messageSuccessfullyCreated = false;
initialState.message                    = defaultMessage();

// Reducer
const messagesReducer = (state = initialState, action) => {
    switch(action.type) {
        case START_CREATING_MESSAGE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                messageSuccessfullyCreated: false,
                successMessage: null,
                loadingErrorMessage: null,
                // Ensure sane default message for creation
                message: {
                    ...defaultMessage(),
                    // recipients, users_ids and activities_ids
                    // can be injected from another page
                    // so we have to keep them when we start
                    // creating a message
                    users_ids: state.message?.users_ids ?? [],
                    activities_ids: state.message?.activities_ids ?? [],
                    recipients: state.message?.recipients ?? []
                }
            };
        case SET_USERS_IDS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                messageSuccessfullyCreated: false,
                successMessage: null,
                loadingErrorMessage: null,
                message: {
                    ...defaultMessage(),
                    users_ids: action.users_ids
                }
            };
        case SET_ACTIVITIES_IDS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                messageSuccessfullyCreated: false,
                successMessage: null,
                loadingErrorMessage: null,
                message: {
                    ...defaultMessage(),
                    activities_ids: action.activities_ids
                }
            };
        case SET_RECIPIENTS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                messageSuccessfullyCreated: false,
                successMessage: null,
                loadingErrorMessage: null,
                message: {
                    ...defaultMessage(),
                    recipients: action.recipients
                }
            };
        case CREATING_MESSAGE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                messageSuccessfullyCreated: false,
                successMessage: null,
                loadingErrorMessage: null,
            };
        case CREATING_MESSAGE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                messageSuccessfullyCreated: true,
                successMessage: action.message.success,
                // Ensure sane default message after creation
                message: defaultMessage()
            };
        case CREATING_MESSAGE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                messageSuccessfullyCreated: false,
                loadingErrorMessage: action.error.message
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        linkedResourcesReducer, messagesReducer
    ]);
}

// Actions
function creatingMessage() { return { type: CREATING_MESSAGE } }
function creatingMessageSuccess(message) { return { type: CREATING_MESSAGE_SUCCESS, message: message} }
function creatingMessageFailure(err) { return { type: CREATING_MESSAGE_FAILURE, error: err } }
export function startCreateMessage() { return { type: START_CREATING_MESSAGE } }
export function createMessage(message) {
    return (dispatch) => {
        dispatch(creatingMessage());
        Messages.create(message)
            .then(data => {
                dispatch(creatingMessageSuccess(data.flash));
            })
            .catch(err => {
                dispatch(creatingMessageFailure(err))
            });
    }
}
export function setMessagesUsersIds(users_ids) {
    return dispatch => dispatch({ type: SET_USERS_IDS, users_ids });
}
export function setMessagesActivitiesIds(activities_ids) {
    return dispatch => dispatch({ type: SET_ACTIVITIES_IDS, activities_ids });
}
export function setMessagesRecipients(recipients) {
    return dispatch => dispatch({ type: SET_RECIPIENTS, recipients });
}
export const getMessagesLinkedResources = linkedResourcesAction;
